import React from 'react';
import AuthLinks from './AuthLinks';
import AnonLinks from './AnonLinks';

import { useAppContext } from '../../../store/appContext';

const ActionLinks = () => {
  const { auth } = useAppContext();
  return (
    <>
      {auth && <AuthLinks />}
      {!auth && <AnonLinks />}
    </>
  );
};

export default ActionLinks;
